import { render, staticRenderFns } from "./bot-inbound-phone.vue?vue&type=template&id=0dfc3654&"
import script from "./bot-inbound-phone.vue?vue&type=script&lang=js&"
export * from "./bot-inbound-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports